import React, { useEffect, useMemo, useState } from 'react';
import { Auth } from 'aws-amplify';
import { resolveTabAccess } from '../auth/pageAccess';
import { useLocation, useNavigate } from 'react-router-dom';

import LabelPrintModal from '../components/LabelPrintModal';

const getQueryParam = (search, key) => {
  try {
    const params = new URLSearchParams(search || '');
    return params.get(key) || '';
  } catch {
    return '';
  }
};

export default function AdminLabelPrint() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const labelUrl = useMemo(() => {
    const raw = getQueryParam(location?.search || '', 'url');
    return String(raw || '').trim();
  }, [location?.search]);

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        setError('');
        const session = await Auth.currentSession();
        const access = await resolveTabAccess(session, 'Orders/Reports');
        if (!access.allowed) {
          navigate(access.isPosAdmin ? '/admin/channels/pos/queue' : '/admin/login');
          return;
        }
      } catch {
        navigate('/admin/login');
        return;
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [navigate]);

  const printableUrl = useMemo(() => {
    if (!labelUrl) return '';
    try {
      const u = new URL(labelUrl);
      const isHttp = u.protocol === 'http:' || u.protocol === 'https:';
      return isHttp ? u.toString() : '';
    } catch {
      return '';
    }
  }, [labelUrl]);

  const close = () => {
    try {
      if (window.history.length > 1) {
        navigate(-1);
        return;
      }
      window.close();
    } catch {
      navigate('/admin/dashboard');
    }
  };

  return (
    <>
      {error ? <div className="alert alert-error">{error}</div> : null}
      <LabelPrintModal open={!loading} labelUrl={printableUrl} onClose={close} />
    </>
  );
}
